import React from 'react';
import { Card, CardContent, Typography, Chip, Box } from '@mui/material';
import { formatDistanceToNow, differenceInCalendarDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { stageLabel } from '../../utils/labels';

function lifeDays(plant) {
    const start = plant.startDate ? new Date(plant.startDate) : null;
    if (!start) return null;
    const end = plant.status === 'archived' && plant.endDate ? new Date(plant.endDate) : new Date();
    return Math.max(0, differenceInCalendarDays(end, start));
}

export default function PlantCard({ plant }) {
    const days = lifeDays(plant);
    const archived = plant.status === 'archived';
    const harvested = archived && plant.endType === 'harvested';
    return (
        <Card sx={{ border: archived ? '2px solid #666' : '2px solid #4CAF50' }}>
            <CardContent>
                <Typography variant="h6">{plant.name}</Typography>
                <Typography variant="body2" color="textSecondary">{plant.strain}</Typography>
                <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Chip label={stageLabel(plant.growthStage)} size="small" color="primary" />
                    {archived && (
                        <Chip
                            label={harvested ? 'Colhida' : 'Finalizada'}
                            size="small"
                            color={harvested ? 'success' : 'default'}
                        />
                    )}
                </Box>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    {days !== null ? `⏱️ ${days} dia(s) de vida` : '—'}
                </Typography>
                {archived && plant.history?.durationDays != null && (
                    <Typography variant="caption" color="textSecondary" display="block">
                        Ciclo encerrado em {formatDistanceToNow(new Date(plant.endDate), { addSuffix: true, locale: ptBR })}
                    </Typography>
                )}
                {harvested && plant.wetWeight != null && (
                    <Typography variant="caption" color="textSecondary" display="block">
                        💧 Peso úmido: {plant.wetWeight}g
                    </Typography>
                )}
                {harvested && plant.dryWeight != null && (
                    <Typography variant="caption" color="textSecondary" display="block">
                        🌿 Peso seco: {plant.dryWeight}g
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
}
